/*
 * @Description: 
 * @Autor: wk
 * @Date: 2019-09-24 10:53:57
 * @LastEditors: wk
 * @LastEditTime: 2019-11-19 15:16:22
 */
const { pathname } = window.location

export function getQuery(key) {
  const str = window.location.search
  if (!str) return ''
  const arr = str.substr(1).split('&')
  const param = {}
  arr.forEach((item) => {
    const arr1 = item.split('=')
    const [k, v] = arr1
    param[k] = v && v.replace(/%20/, '+')
  })
  
  return param[key] || ''
}

export function saveLoginId(query) {
  const id = query.loginId
  sessionStorage.setItem('work-order-login-id', id)
}

export function getLoginId() {
  const id = localStorage.getItem('users') ? JSON.parse(localStorage.getItem('users')).empId : getQuery('loginId')
  return id
}

export function addRequestParam(param) {
  if (!param.loginId) param.loginId = getLoginId()
  return param
}

export function returnReqURI(url) {
  const regionId = getQuery('regionId')
  let popUri = '/popxinyunadmin/admin/xinyunpop/'
  const xinyunUri = '/yunjixinyunadmin/admin/xinyun/'
  if (regionId === '5') {
    popUri = '/supplierworkorderadmin/admin/xinyunpop/'
  }
  if (pathname.includes('popWeb') || pathname.includes('popadminweb')) {
    if (window.location.host === 'popxinyunadmin.yunjiglobal.com' && regionId === '5') popUri = `https://agent.yunjiglobal.com${popUri}`
    const i = url.lastIndexOf('/')
    url = `workorder/extend${url.substr(i)}`
    url = `${popUri}${url}`
  } else if (pathname.includes('xinyunweb')) {
    url = `${xinyunUri}${url}`
  }
  return url
}
